/** @jsx jsx */
import { jsx, css } from "@emotion/react";
import { breakpoints, colors, fontSize } from "style";
import Image from "components/Image";

/**
 * MemberTestimonialCard
 *
 * @param   {Object}   testimonial
 */
const MemberTestimonialCard = ({ testimonial }) => (
  <div css={styles.cardWrapper}>
    <div css={styles.card}>
      <div css={styles.header}>
        <div css={styles.imageWrapper}>
          <Image url={testimonial.image} alt={testimonial.name} css={styles.image} />
        </div>
        <div css={styles.nameWrapper}>
          <p css={styles.name}>{testimonial.name}</p>
          <p css={styles.designation}>{testimonial.designation}</p>
        </div>
      </div>
      <div css={styles.messageWrapper}>
        <p css={styles.message}>{testimonial.message}</p>
      </div>
    </div>
  </div>
);

const styles = {
  cardWrapper: css`
    width: calc(100% / 3);
    flex-shrink: 0;
    padding: 0 10px;
    display: flex;

    @media (max-width: ${breakpoints.tablet}) {
      width: calc(100% / 2);
      padding: 0 8px;
    }

    @media (max-width: ${breakpoints.mobile}) {
      width: 100%;
      padding: 0 4px;
    }
  `,
  card: css`
    width: 100%;
    min-height: 280px;
    background: ${colors.white};
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: ${breakpoints.tablet}) {
      padding: 20px;
      min-height: auto;
    }

    @media (max-width: ${breakpoints.mobile}) {
      padding: 18px;
      min-height: auto;
    }
  `,
  header: css`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    min-height: 85px;

    @media (max-width: ${breakpoints.tablet}) {
      min-height: 80px;
    }

    @media (max-width: ${breakpoints.mobile}) {
      gap: 10px;
      min-height: 75px;
    }
  `,
  imageWrapper: css`
    width: 60px;
    height: 60px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;

    @media (max-width: ${breakpoints.mobile}) {
      width: 50px;
      height: 50px;
    }
  `,
  image: css`
    width: 100%;
    height: 100%;
    object-fit: cover;
  `,
  nameWrapper: css`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 4px;
    align-items: flex-start;
  `,
  name: css`
    font-size: ${fontSize.normal};
    font-weight: 600;
    color: ${colors.grayAnatomyDark};
    line-height: 1.3;
    margin: 0;
    text-align: left;

    @media (max-width: ${breakpoints.mobile}) {
      font-size: ${fontSize.small};
    }
  `,
  designation: css`
    font-size: ${fontSize.small};
    color: ${colors.grayAnatomyMedium};
    font-weight: 500;
    margin: 0;
    line-height: 1.4;
    text-align: left;

    @media (max-width: ${breakpoints.mobile}) {
      font-size: ${fontSize.xsmall};
    }
  `,
  messageWrapper: css`
    padding: 16px 0 0 0;
  `,
  message: css`
    font-size: ${fontSize.normal};
    line-height: 1.7;
    color: ${colors.grayAnatomyDark};
    margin: 0;
    text-align: left;

    @media (max-width: ${breakpoints.mobile}) {
      font-size: ${fontSize.small};
      line-height: 1.6;
    }
  `,
};

export default MemberTestimonialCard;
